<!--表单页面拷贝开始-->
<template>
    <div>
      <form-components @submitForm="submitForm">
        <template v-slot:content>
          <el-form-item label="名称" >
              <el-col :span="8">
                <el-input v-model="sysDepository.name" ></el-input>
              </el-col>
            </el-form-item>
          <el-form-item label="链接地址" >
              <el-col :span="8">
                <el-input v-model="sysDepository.url" ></el-input>
              </el-col>
            </el-form-item>
          <el-form-item label="类型" >
            <el-col :span="8">
              <el-select v-model="sysDepository.type" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            </el-col>
            </el-form-item>
          <el-form-item label="是否推荐" >
              <el-col :span="8">
                 <el-select v-model="sysDepository.isRecommand" placeholder="请选择">
                  <el-option
                    v-for="item in recommands"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
          </el-form-item>

          <el-form-item label="所属区域" >
              <el-col :span="8">
                 <el-select v-model="sysDepository.area" placeholder="请选择">
                  <el-option
                    v-for="item in areas"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
          </el-form-item>

          <el-form-item label="备注信息" >
              <el-col :span="8">
                <el-input type="textarea" :rows="5" v-model="sysDepository.remark" ></el-input>
              </el-col>
            </el-form-item>
        </template>
      </form-components>
    </div>
  </template>
  
  <script>
  import FormComponents from "@/components/form/FormComponents";
  import SysDepositoryApi from '@/api/SysDepositoryApi'
  import { navTo,queryParam } from "@/utils/NavigatorUtils";
  export default {
    name: "SaveSysDepositoryPage",
    props: {
      msg: String,
    },
    components: {
      FormComponents
    },
    data() {
      return {
        sysDepository:{
          name:"",
          url:"",
          id:0,
          type:"",
          isRecommand:0,
          area:"chengdu"
        },
        options:[
        {
          value:"software",
          label:"软件镜像"
        },
        {
          value:"frontend",
          label:"前端资源"
        },
        {
          value:"monitor",
          label:"监控接口资源"
        }
      ],
      recommands:[
        {
          value:1,
          label:"推荐"
        },
        {
          value:0,
          label:"不推荐"
        }
      ],
      areas:[
        {
          value:"",
          label:"不限"
        },
        {
          value:"chengdu",
          label:"成都"
        },
        {
          value:"xian",
          label:"西安"
        },
        {
          value:"urumqi",
          label:"乌鲁木齐"
        }
      ]
      }
    },
    created(){
      this.sysDepository = this.$route.params;
    },
    methods:{
      submitForm(){
        this.sysDepository.id>0?this.updateSysDepositoryById():this.addSysDepository()
      },
      addSysDepository(){
        SysDepositoryApi.saveSysDepository(this.sysDepository).then((resp)=>{
          if(resp.state=="OK"){
            this.sysDepository={}
            this.$successMsg(resp.msg)
           
          }else{
            this.$errorMsg(resp.msg)
          }
        })
      },
      updateSysDepositoryById(){
        SysDepositoryApi.updateSysDepository(this.sysDepository).then((resp)=>{
          if(resp.state=="OK"){
            this.user={}
            this.$successMsg(resp.msg);
             navTo(this,"/sysDepositoryList")
          }else{
            this.$errorMsg(resp.msg)
          }
        })
      }
    }
  };
  </script>
  
  
  <!--表单页面拷贝结束-->